import { useTranslation } from 'react-i18next'
import { EPollType } from '../../../types/enums'
import { trpc } from '../../../utils'
import { Button, Checkbox } from '../../atoms'
import { InputRanged } from '../../molecules'
import { usePlayerControlsLogic } from './hooks'
import {
  actionButtons,
  betInputBlock,
  betInputSection,
  betMilestoneButton,
  betMilestoneButtons,
  controlButton,
  gridWrapper,
  PlayerControlsStyle,
  suggestButtonsContainer,
  tablePlayerBlock,
} from './index.css'
import type { PlayerControlsPropsType } from './types'

export const PlayerControls = (
  props: Omit<PlayerControlsPropsType, 'showButtons'> & { showButtons: true },
) => {
  const { t } = useTranslation()
  const startPoll = trpc.poll.start.useMutation()

  const logic = usePlayerControlsLogic(props)

  const onSuggestDoubleBoard = () => {
    // props.onSuggestDoubleBoard()
    startPoll.mutate({
      tableId: props.tableId,
      type: EPollType.DOUBLE_BOARD,
      state: startPoll.data ? !startPoll.data.state : true,
    })
  }

  return (
    <div className={PlayerControlsStyle}>
      <div className={gridWrapper}>
        <div className={tablePlayerBlock}>{props.children}</div>

        <div className={actionButtons}>
          {logic.buttons.map((button, index) => (
            <Button
              key={index}
              className={controlButton}
              hidden={button.hidden}
              analytic={{
                name: 'action',
                params: {
                  action: button.name,
                },
              }}
              onClick={button.onClick}
            >
              {button.label}
            </Button>
          ))}
        </div>

        <div className={betInputBlock}>
          {logic.betSettings.show ? (
            <>
              <div className={betMilestoneButtons}>
                {logic.milestoneButtons.map((button) => (
                  <Button
                    key={button.label}
                    className={betMilestoneButton}
                    analytic={{
                      name: 'milestone',
                      params: {
                        milestone: button.name ?? button.label.toLowerCase(),
                      },
                    }}
                    onClick={button.onClick}
                  >
                    {button.label}
                  </Button>
                ))}
              </div>
              <InputRanged
                {...logic.betSettings}
                classNameContainer={betInputSection}
              />
            </>
          ) : null}

          {props.isDoubleBoardPossible && !props.isDoubleBoardActive ? (
            <div className={suggestButtonsContainer}>
              <Checkbox
                state={startPoll.data?.state || false}
                label={t('table.label.suggestDoubleBoard')}
                analytic={{
                  name: 'suggest_double_board',
                }}
                onToggle={onSuggestDoubleBoard}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
